<div *ngIf="descriptor" [formGroup]="form" >

    <div [formArrayName]="descriptor.controlName">

        <div *ngFor="let control of formArray.controls; let i = index;"
            [formGroupName]="i">

            <div class="vedrax-nvp-container">
                <div class="vedrax-nvp-30">{{control.get('key')?.value}}</div>
                <div class="vedrax-nvp-70">
                    <mat-form-field appearance="outline">
                        <input type="number" required matInput formControlName="value">
                    </mat-form-field>
                </div>
            </div>

        </div>

    </div>

</div>